import { render } from "./RegisterView.vue?vue&type=template&id=ce9010b8&ts=true"
import script from "./RegisterView.vue?vue&type=script&lang=ts"
export * from "./RegisterView.vue?vue&type=script&lang=ts"

import "./RegisterView.vue?vue&type=style&index=0&id=ce9010b8&lang=css"

import exportComponent from "D:\\Github\\guardsonlinesms\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__